module.exports = __webpack_public_path__ + "static/07-9df8ecd5e82e5421cd6ca9f5194c1b78.jpg";